import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeOff } from 'lucide-react';
import './Login.css';
import logo from "../assets/images/amanak-logo.png";

export default function Login() {
  const { user, login, teamRoles, allTeams, warehouseId } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    const result = await login(email, password);
    if (!result.success) {
      // Show specific error if available
      const msg = result.error?.message || 'فشل تسجيل الدخول. تأكد من صحة البيانات.';
      setError(msg);
      return;
    }
  }

  useEffect(() => {
    if (user) {
      // Check if user has multiple teams and needs to select one
      if (allTeams && allTeams.length > 1 && !warehouseId) {
        navigate('/choose-warehouse');
        return;
      }

      // If warehouse selected (or only one exists), proceed with role checks
      if (warehouseId && teamRoles.length > 0) {
        if (teamRoles.includes('salesOnly')) {
          navigate('/sales-home');
        } else if (teamRoles.includes('production')) {
          navigate('/production');
        } else {
          navigate('/home');
        }
      }
    }
  }, [user, teamRoles, allTeams, warehouseId, navigate]);



  return (
    <div className="login-root-holder" dir="rtl">

      {/*brand header*/}

      <div className="amanak-dad">

        <div className="amanak">
          <p>
            دقة في الحساب <br></br> ثقة في الإدارة
          </p>

          <img className="amanak-logo" src={logo} alt="amanak logo" />

        </div>
      </div>


      <div className="login-root" dir="rtl">
        <h1 className="brand">نظام أمانك لإدارة المخازن والمبيعات</h1>
        <div id="holder">
          <h1 className="title">تسجيل دخول</h1>
          {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}
          <form onSubmit={handleSubmit} className="login-form">
            <label htmlFor="email" className="input-lable">البريد الإلكتروني:</label>
            <input
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="password" className="input-lable">كلمة المرور:</label>
            <div className="password-wrapper">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </span>
            </div>
            <button type="submit">تسجيل الدخول</button>
          </form>
        </div>
      </div>
      <div className="sign-up">
        <p>ليس لديك حساب؟ تواصل معنا</p>
        <a href='https://wa.me/message/STKXQTAFDC37A1' id='signup-btn'>إنشاء حساب</a>

      </div>
    </div>
  );
}
